(() => {
  if (!window.theme?.NewsletterPopup) return;
  const prototype = window.theme.NewsletterPopup.prototype;
  const originalUnload = prototype.onUnload;
  prototype.initPopupDelay = function () {
    if (this.data.testMode === 'true') return;
    if (!document.body.matches('.template-index, .template-collection')) return;
    let appeared;
    try { appeared = sessionStorage.getItem('newsletterAppeared') === 'true'; }
    catch (_) { appeared = true; }
    if (appeared) return;
    let elapsed = false;
    let explored = false;
    const events = ['scroll', 'visibilitychange', 'drawerClose', 'modalClose'];
    const cleanup = () => {
      clearTimeout(timer);
      events.forEach(name => document.removeEventListener(name, attempt));
      this.hgbPopupCleanup = null;
    };
    const attempt = () => {
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0 && window.scrollY >= Math.min(distance * 0.35, 900)) explored = true;
      if (!elapsed || !explored || document.hidden) return;
      if (document.documentElement.matches('.js-drawer-open, .modal-open')) return;
      if (document.activeElement?.matches('input, textarea, select')) return;
      try {
        if (sessionStorage.getItem('newsletterAppeared') === 'true') { cleanup(); return; }
        sessionStorage.setItem('newsletterAppeared', 'true');
      } catch (_) { cleanup(); return; }
      cleanup();
      this.modal.open();
    };
    const timer = setTimeout(() => { elapsed = true; attempt(); }, Math.max(30, Number(this.data.secondsBeforeShow) || 30) * 1000);
    events.forEach(name => document.addEventListener(name, attempt, {passive: true}));
    this.hgbPopupCleanup = cleanup;
  };
  prototype.onUnload = function () {
    this.hgbPopupCleanup?.();
    return originalUnload?.call(this);
  };
})();
